export enum CalAttendeeType {
    ALIAS = 'alias',
    ORGAN = 'org',
    USER = 'user'
}
